export default __webpack_public_path__ + "static/media/projects.249b4607.svg";